
class SupportFileViewController extends BaseTableViewController
{
    static newInstance():SupportFileViewController {
        return new SupportFileViewController();
    }
}